import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { INoahDeviceReadOut, INoahDeviceReadOutsQueryParams, IQueryResult } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<INoahDeviceReadOut>, INoahDeviceReadOutsQueryParams>>(undefined as any);
